import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../../../components/panel/panel";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Alert from "react-bootstrap/Alert";
import * as formik from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import axiosClient from "../../../../config/axios.js";
import OrderResultModal from "./OrderResultModal";

function CreateEmptyOrdersVial() {
  const { Formik } = formik;
  const [serviceTypes, setServiceTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [resultModalOpen, setResultModalOpen] = useState(false);
  const [resultData, setResultData] = useState(null);

  useEffect(() => {
    setLoading(true);
    axiosClient
      .get("/typeServices/datatable")
      .then((response) => {
        const options = response.data.data
          .filter((item) => item.type_service_name !== "Guardia nacional")
          .map((item) => ({
            value: item.id,
            label: item.type_service_name,
          }));
        setServiceTypes(options);
      })
      .catch((error) => {
        console.error("Error al obtener tipos de servicio:", error);
        Swal.fire({
          title: "Error",
          text: "No se pudieron cargar los tipos de servicio",
          icon: "error",
          confirmButtonText: "Aceptar",
        });
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/">Inicio</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/catalogs">Catálogos</Link>
            </li>
            <li className="breadcrumb-item active">
              Crear órdenes Varo Express
            </li>
          </ol>
          <h1 className="page-header mb-0">Crear órdenes Varo Express</h1>
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-xl-12">
          <Panel>
            <PanelHeader>Crear órdenes vacías de forma masiva</PanelHeader>
            <PanelBody>
              <Formik
                validationSchema={yup.object().shape({
                  serie: yup.string().required("Ingrese la serie del folio"),
                  folioInicio: yup
                    .number()
                    .typeError("El folio inicial debe ser un número")
                    .positive("El folio inicial debe ser mayor a 0")
                    .required("Ingrese el folio inicial"),
                  folioFinal: yup
                    .number()
                    .typeError("El folio final debe ser un número")
                    .positive("El folio final debe ser mayor a 0")
                    .min(
                      yup.ref("folioInicio"),
                      "El folio final debe ser mayor o igual al folio inicial"
                    )
                    .required("Ingrese el folio final"),
                  tipoServicio: yup
                    .number()
                    .typeError("Debe seleccionar un tipo de servicio")
                    .required("Seleccione un tipo de servicio"),
                })}
                initialValues={{
                  serie: "",
                  folioInicio: "",
                  folioFinal: "",
                  tipoServicio: "",
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setSubmitting(true);
                  const payload = {
                    ...values,
                    tipoServicio: parseInt(values.tipoServicio),
                    folioInicio: parseInt(values.folioInicio),
                    folioFinal: parseInt(values.folioFinal),
                  };
                  axiosClient
                    .post("/order-vial/create-empty-orders", payload)
                    .then((response) => {
                      setResultData({ data: response.data });
                      setResultModalOpen(true);
                      resetForm();
                    })
                    .catch((err) => {
                      console.error("Error al crear órdenes:", err);
                      const errorMessage =
                        err.response?.data?.message ||
                        err.response?.data?.error ||
                        "No se pudieron crear las órdenes. Verifique los datos e intente nuevamente.";

                      Swal.fire({
                        title: "Error",
                        text: errorMessage,
                        icon: "error",
                        confirmButtonText: "Aceptar",
                      });
                    })
                    .finally(() => {
                      setSubmitting(false);
                    });
                }}
              >
                {({
                  handleSubmit,
                  handleChange,
                  handleBlur,
                  values,
                  touched,
                  errors,
                  isSubmitting,
                }) => (
                  <Form noValidate onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Serie del folio{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="serie"
                            placeholder="Ejemplo: TM "
                            value={values.serie}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.serie && !!errors.serie}
                            disabled={isSubmitting || loading}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.serie}
                          </Form.Control.Feedback>
                          <Form.Text className="text-muted">
                            La serie que se usará para generar los folios
                            (ejemplo: TM )
                          </Form.Text>
                        </Form.Group>
                      </Col>

                      <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Folio inicial <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="number"
                            name="folioInicio"
                            placeholder="Ejemplo: 20"
                            value={values.folioInicio}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onWheel={(e) => {
                              e.target.blur();
                            }}
                            isInvalid={
                              touched.folioInicio && !!errors.folioInicio
                            }
                            disabled={isSubmitting || loading}
                            min="1"
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.folioInicio}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>

                      <Col md={3}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Folio final <span className="text-danger">*</span>
                          </Form.Label>
                          <Form.Control
                            type="number"
                            name="folioFinal"
                            placeholder="Ejemplo: 25"
                            value={values.folioFinal}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            onWheel={(e) => {
                              e.target.blur();
                            }}
                            isInvalid={
                              touched.folioFinal && !!errors.folioFinal
                            }
                            disabled={isSubmitting || loading}
                            min={values.folioInicio || 1}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.folioFinal}
                          </Form.Control.Feedback>
                          <Form.Text className="text-muted">
                            Debe ser mayor o igual al folio inicial
                          </Form.Text>
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>
                            Tipo de servicio{" "}
                            <span className="text-danger">*</span>
                          </Form.Label>
                          {loading ? (
                            <div className="text-center my-4">
                              <i className="fa fa-spinner fa-spin fa-3x"></i>
                              <p>Cargando tipos de servicio...</p>
                            </div>
                          ) : (
                            <Form.Select
                              name="tipoServicio"
                              value={values.tipoServicio}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                touched.tipoServicio && !!errors.tipoServicio
                              }
                              disabled={isSubmitting || loading}
                            >
                              <option value="">
                                Selecciona un tipo de servicio
                              </option>
                              {serviceTypes.map((type) => (
                                <option key={type.value} value={type.value}>
                                  {type.label}
                                </option>
                              ))}
                            </Form.Select>
                          )}
                          <Form.Control.Feedback type="invalid">
                            {errors.tipoServicio}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>

                    {values.folioInicio && values.folioFinal && (
                      <Row className="mb-3">
                        <Col md={12}>
                          <Alert variant="info">
                            <strong>Resumen:</strong> Se crearán órdenes con
                            folios desde{" "}
                            <strong>
                              {values.serie || "SERIE-"}
                              {String(values.folioInicio).padStart(4, "0")}
                            </strong>{" "}
                            hasta{" "}
                            <strong>
                              {values.serie || "SERIE-"}
                              {String(values.folioFinal).padStart(4, "0")}
                            </strong>
                            . Total:{" "}
                            <strong>
                              {values.folioFinal - values.folioInicio + 1}
                            </strong>{" "}
                            órdenes
                            {values.folioInicio > values.folioFinal && (
                              <span className="text-danger">
                                {" "}
                                (El folio inicial debe ser menor o igual al
                                folio final)
                              </span>
                            )}
                          </Alert>
                        </Col>
                      </Row>
                    )}

                    <Row className="mb-3">
                      <Col md="12">
                        <Button
                          type="submit"
                          disabled={isSubmitting || loading}
                          variant="success"
                        >
                          {isSubmitting ? (
                            <>
                              <i className="fa fa-spinner fa-spin me-2"></i>
                              Creando órdenes...
                            </>
                          ) : (
                            <>
                              <i className="fa fa-plus me-2"></i>
                              Crear órdenes
                            </>
                          )}
                        </Button>{" "}
                        <Link
                          to={"/catalogs"}
                          className="btn btn-secondary"
                          disabled={isSubmitting}
                        >
                          Cancelar
                        </Link>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Formik>
            </PanelBody>
          </Panel>
        </div>
      </div>

      <OrderResultModal
        isOpen={resultModalOpen}
        resultData={resultData}
        onClose={() => {
          setResultModalOpen(false);
          setResultData(null);
        }}
      />
    </div>
  );
}

export default CreateEmptyOrdersVial;
